// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__n6Jhc","social":"socials__social__SUQD2","icon":"socials__icon__uQ9yp","navOpen":"socials__navOpen__liH5V"};